import { api } from "@/api/client";
import type { PageInfo, UserDetail, UserSummary } from "@/types/api";

export interface UserCreateRequest {
  username: string;
  password: string;
  is_admin?: boolean;
  permissions?: string[];
}

export interface UserUpdateRequest {
  password?: string;
  is_admin?: boolean;
  is_active?: boolean;
  permissions?: string[];
}

export async function listUsers(): Promise<UserSummary[]> {
  const { data } = await api.get<UserSummary[]>("/admin/users");
  return data;
}

export async function getUser(id: number): Promise<UserDetail> {
  const { data } = await api.get<UserDetail>(`/admin/users/${id}`);
  return data;
}

export async function createUser(body: UserCreateRequest): Promise<UserDetail> {
  const { data } = await api.post<UserDetail>("/admin/users", body);
  return data;
}

export async function updateUser(
  id: number,
  body: UserUpdateRequest,
): Promise<UserDetail> {
  const { data } = await api.put<UserDetail>(`/admin/users/${id}`, body);
  return data;
}

export async function deleteUser(id: number): Promise<void> {
  await api.delete(`/admin/users/${id}`);
}

export async function listAvailablePages(): Promise<PageInfo[]> {
  const { data } = await api.get<PageInfo[]>("/admin/available-pages");
  return data;
}
